import { render, staticRenderFns } from "./comments-header.vue?vue&type=template&id=d4a8d6fe"
import script from "./comments-header.vue?vue&type=script&lang=js"
export * from "./comments-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports